import { Event } from "@app/core/tracking/domain/event";

/**
 * Event triggered when the user scrolls on the catalog pages (Category, Product...).
 */
export class CatalogScrolledEvent extends Event{
}